const API_HOST = process.env.REACT_APP_API_HOST || 'https://devcloud-api.ahmedkira.com';
// const API_HOST = 'http://localhost:5000';
export {
    API_HOST
};
